module.exports = __webpack_public_path__ + "img/doctor_detail_bg.60eebfc7.png";